import React, { useState } from "react";
import Button from "@mui/material/Button";
import { TextField, PrimaryButton, DatePicker } from "@fluentui/react";
import { GetGrayOutReportData } from "../Services/JobConfigurationServices";
import CommonDataTable from "./CommonDataTable";
import { ReportExcelExport } from "./ExportExcel/ReportExcelExport";
import { format } from "date-fns";

const GrayOutReport = () => {
  const [records, setRecords] = useState([]);
  const [filteredRecords, setFilteredRecords] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  const column = [
    {
      name: "JobId",
      cell: (row) => <span>{row.JobId}</span>,
      width: "200px",
    },
    {
      name: "Table",
      cell: (row) => <span>{row.Table}</span>,
      width: "200px",
    },
    {
      name: "Carrier",
      cell: (row) => <span>{row.Carrier}</span>,
      width: "200px",
    },
    {
      name: "Lob",
      cell: (row) => <span>{row.Lob}</span>,
    },
    {
      name: "ChecklistQuestion",
      cell: (row) => <span>{row.ChecklistQuestion}</span>,
      width: "200px",
    },
    {
      name: "CtCount",
      cell: (row) => <span>{row.CtCount}</span>,
      width: "100px",
    },
    {
      name: "ptCount",
      cell: (row) => <span>{row.ptCount}</span>,
      width: "100px",
    },
    {
      name: "PropCount",
      cell: (row) => <span>{row.PropCount}</span>,
      width: "100px",
    },
    {
      name: "AppCount",
      cell: (row) => <span>{row.AppCount}</span>,
      width: "100px",
    },
    {
      name: "QuoCount",
      cell: (row) => <span>{row.QuoCount}</span>,
      width: "100px",
    },
    {
      name: "BinCount",
      cell: (row) => <span>{row.BinCount}</span>,
      width: "100px",
    },
    {
      name: "SchCount",
      cell: (row) => <span>{row.SchCount}</span>,
      width: "100px",
    },
    {
      name: "CtListedCount",
      cell: (row) => <span>{row.CtListedCount}</span>,
      width: "150px",
    },
    {
      name: "CtAttchedCount",
      cell: (row) => <span>{row.CtAttchedCount}</span>,
      width: "150px",
    },
  ];

  const getData = async () => {
    try {
      document.body.classList.add("loading-indicator");
      const response = await GetGrayOutReportData(fromDate, toDate);
      if (response && Array.isArray(response)) {
        setRecords(response);
        setFilteredRecords(response);
      } else {
        setRecords([]);
        setFilteredRecords([]);
      }
    } catch (error) {
      document.body.classList.remove("loading-indicator");
      // handle the error
    } finally {
      document.body.classList.remove("loading-indicator");
    }
  };

  const onChange = (event) => {
    const text = event.target.value;
    setSearchText(text); // Update state immediately

    if (text?.trim()) {
      const searchTerm = text.toLowerCase().trim();

      const filteredData = records?.filter(
        (f) =>
          f?.JobId?.toLowerCase()?.trim()?.includes(searchTerm) ||
          f?.Table?.toLowerCase()?.trim()?.includes(searchTerm) ||
          f?.Carrier?.toLowerCase()?.trim()?.includes(searchTerm) ||
          f?.Lob?.toLowerCase()?.trim()?.includes(searchTerm) ||
          f?.ChecklistQuestion?.toLowerCase()?.trim()?.includes(searchTerm)
      );

      setFilteredRecords(filteredData);
    } else {
      setFilteredRecords(records); // Show all data when search is cleared
    }
  };

  const exportData = () => {
    if (filteredRecords && filteredRecords?.length > 0) {
      const dataForExport = [{ data: filteredRecords }];
      const today = new Date();
      const day = String(today.getDate());
      const month = String(today.getMonth() + 1);
      const year = today.getFullYear();

      const formattedDate = `${day}_${month}_${year}`;
      const fileName = `${formattedDate}_GrayOutReport`;
      ReportExcelExport(dataForExport, fileName);
    }
  };

  const onFromDateChange = (date) => {
    if (date) {
      const formattedDate = format(date, "M/d/yyyy");
      setFromDate(formattedDate);
      setToDate(null); // Reset toDate when fromDate changes
    } else {
      setFromDate(null);
    }
  };

  const onToDateChange = (date) => {
    if (date) {
      const formattedDate = format(date, "M/d/yyyy");
      setToDate(formattedDate);
    } else {
      setToDate(null);
    }
  };

  return (
    <div style={{ padding: "2px" }}>
      <br />
      <div style={{ display: "flex", justifyContent: "start" }}>
        <div
          style={{
            display: "flex",
            gap: "20px",
            flexWrap: "wrap",
            padding: "10px",
          }}
        >
          <DatePicker
            style={{ width: "200px" }}
            placeholder="From Date..."
            onSelectDate={onFromDateChange}
            value={fromDate ? new Date(fromDate) : null}
            allowTextInput
          />
          <DatePicker
            style={{ width: "200px" }}
            placeholder="To Date..."
            onSelectDate={onToDateChange}
            value={toDate ? new Date(toDate) : null}
            minDate={fromDate ? new Date(fromDate) : null}
            //   disabled={!fromDate}
            allowTextInput
          />
          <PrimaryButton
            disabled={!fromDate || !toDate}
            onClick={() => {
              getData();
            }}
          >
            Search
          </PrimaryButton>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          {records && records?.length > 0 && (
            <>
              <div style={{ display: "flex", justifyContent: "end" }}>
                <TextField
                  placeholder="Search..."
                  value={searchText}
                  onChange={onChange} // Direct function reference
                  style={{
                    width: "250px",
                    marginRight: "8px",
                  }}
                />
                <PrimaryButton
                  text={
                    <span style={{ color: "white", fontWeight: "bold" }}>
                      Search
                    </span>
                  }
                  //   onClick={() => {
                  //     filterData();
                  //   }}
                  style={{
                    marginLeft: "-50px",
                    height: "32.1px",
                    fontSize: "10px",
                  }}
                />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </div>
              <div>
                <PrimaryButton key="bC2" onClick={() => exportData()}>
                  Export
                </PrimaryButton>
              </div>
            </>
          )}
        </div>
      </div>
      <br />
      <div>
        <CommonDataTable
          key={"jData"}
          column={column}
          data={searchText?.trim() ? filteredRecords : records}
        />
      </div>
    </div>
  );
};

export default GrayOutReport;
